import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess, _TechnicalSkillLevel, _TransversalSkillLevel } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { EntailmentEditor } from "../Entailment/Entailment.editor";

interface Props {
    IDTechnicalSkillType: number;
}

export const TechnicalSkillLevel = ({ IDTechnicalSkillType }: Props) => {

    const TechnicalSkillLevel = useDataBean(_TechnicalSkillLevel);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDTechnicalSkillType])

    const getLista = () => {

        TechnicalSkillLevel.instance.getTechnicalSkillLevelCatalog(IDTechnicalSkillType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        TechnicalSkillLevel.setBean({
            IDTechnicalSkillType: IDTechnicalSkillType,
            IDEntailment: TechnicalSkillLevel.bean.IDEntailment
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        TechnicalSkillLevel.instance.deleteTechnicalSkillLevel(TechnicalSkillLevel.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        TechnicalSkillLevel.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTechnicalSkillLevel', visible: true },

        { title: 'Tipos de Asignación', property: 'IDEntailment', visible: true },
        { title: 'Fecha', property: 'Since', visible: true }

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={TechnicalSkillLevel.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <EntailmentEditor idSelector={TechnicalSkillLevel.bean.IDEntailment} onChange={(e) => { TechnicalSkillLevel.setBean({ ...TechnicalSkillLevel.bean, "IDEntailment": e }) }} />
                        </div>

                        {/* <PrintJson json={SubMacroProcess.bean} /> */}
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}